import React, { useEffect } from 'react';
import InfoIconComponent from '../../InfoIcon';
import style from './ExitTacticModules.module.css';
import PropTypes from 'prop-types';
import ValueListInput from '../../../../../../atomic/inputs/valueListInput/ValueListInput';
import BreakPriceDocs from '../../../../documentation/BreakPriceDocumentation';

function BreakPriceModule({ state }) {
  const [breakPrice, dispatchBreakPrice, , setBreakPriceEnabled] = state;

  useEffect(() => {
    setBreakPriceEnabled(true);
  }, []);

  return (
    <div className={style.moduleStyle}>
      <span className={style.tacticName}>
        <InfoIconComponent docs={BreakPriceDocs} /> Underlying Break Price
      </span>
      <div className={style.inputs}>
        <div className={style.inputAndLabel}>
          <p>Prices</p>
          <ValueListInput
            inputWidth="5.5em"
            direction="left"
            allowRepeats={true}
            addDecimals
            currentValues={breakPrice.prices || []}
            symbol="$"
            onAddDelete={(valueList) =>
              dispatchBreakPrice({
                prices: valueList,
              })
            }
          />
        </div>
      </div>
    </div>
  );
}
BreakPriceModule.propTypes = {
  state: PropTypes.array.isRequired,
};
export default BreakPriceModule;
